import { render, staticRenderFns } from "./AddNewSupplier.vue?vue&type=template&id=223b3826&"
import script from "./AddNewSupplier.vue?vue&type=script&lang=js&"
export * from "./AddNewSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports